<template>
  <v-card class="pa-2 text-center" outlined tile>
    <span v-html="subValue({ cod: Articulo[0].UniVenta })" />
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["Articulo"]),
    subValue: function () {
      return function ({ cod }) {
        if (cod === "M2") {
          const numero = cod.slice(1);
          const character = cod.slice(0, 1).toLowerCase();
          return `${character}<sup>${numero}</sup>`;
        } else return cod;
      };
    },
  },
};
</script>

<style></style>
